module.exports = __webpack_public_path__ + "img/Vision_04.aad03a38.jpg";